<!-- Item wrapper -->
<div class="fuse-vertical-navigation-item-wrapper" [class.fuse-vertical-navigation-item-has-subtitle]="!!item.subtitle" [ngClass]="item.classes?.wrapper">
  <div class="fuse-vertical-navigation-item">
    <!-- Icon -->
    @if (item.icon) {
      <mat-icon class="fuse-vertical-navigation-item-icon" [ngClass]="item.classes?.icon" [svgIcon]="item.icon"></mat-icon>
    }

    <!-- Title & Subtitle -->
    <div class="fuse-vertical-navigation-item-title-wrapper">
      <div class="fuse-vertical-navigation-item-title">
        <span [ngClass]="item.classes?.title">
          {{ item.title }}
        </span>
      </div>

      @if (item.subtitle) {
        <div class="fuse-vertical-navigation-item-subtitle">
          <span [ngClass]="item.classes?.subtitle">
            {{ item.subtitle }}
          </span>
        </div>
      }
    </div>

    <!-- Badge -->
    @if (item.badge) {
      <div class="fuse-vertical-navigation-item-badge">
        <div class="fuse-vertical-navigation-item-badge-content" [ngClass]="item.badge.classes">
          {{ item.badge.title }}
        </div>
      </div>
    }
  </div>
</div>

@for (child of item.children; track trackByFn($index, child)) {
  <!-- Skip hidden items -->
  @if (!(typeof child.hidden === 'function' ? child.hidden(child) : !!child.hidden)) {
    <!-- Basic -->
    @if (child.type === 'basic') {
      <fuse-vertical-navigation-basic-item [item]="child" [name]="name"></fuse-vertical-navigation-basic-item>
    }

    <!-- Collapsable -->
    @if (child.type === 'collapsable') {
      <fuse-vertical-navigation-collapsable-item [item]="child" [name]="name" [autoCollapse]="autoCollapse"></fuse-vertical-navigation-collapsable-item>
    }

    <!-- Divider -->
    @if (child.type === 'divider') {
      <fuse-vertical-navigation-divider-item [item]="child" [name]="name"></fuse-vertical-navigation-divider-item>
    }

    <!-- Group -->
    @if (child.type === 'group') {
      <fuse-vertical-navigation-group-item [item]="child" [name]="name"></fuse-vertical-navigation-group-item>
    }

    <!-- Spacer -->
    @if (child.type === 'spacer') {
      <fuse-vertical-navigation-spacer-item [item]="child" [name]="name"></fuse-vertical-navigation-spacer-item>
    }
  }
}
